export default "__VITE_ASSET__B9zUI8wO__"